import {createContext} from 'react'

export const CommissionContext = createContext()
